import type { PageSizeOption } from '@econtractor/types';

export const PAGE_SIZE_OPTIONS: readonly PageSizeOption[] = [10, 25, 50, 100];

export const DEFAULT_PAGE_SIZE: PageSizeOption = 25;

export const normalizePageSize = (
    value: unknown,
    fallback: number = DEFAULT_PAGE_SIZE,
): PageSizeOption => {
    const parsed = parseInt(String(value), 10);
    if ((PAGE_SIZE_OPTIONS as readonly number[]).includes(parsed)) {
        return parsed as PageSizeOption;
    }

    const fallbackParsed = parseInt(String(fallback), 10);
    if ((PAGE_SIZE_OPTIONS as readonly number[]).includes(fallbackParsed)) {
        return fallbackParsed as PageSizeOption;
    }

    return DEFAULT_PAGE_SIZE;
};
